import { datadogRum } from '@datadog/browser-rum';

interface ErrorData {
  extras?: {
    [key: string]: any;
  };
}

/**
 * Logs an error to Datadog RUM. Accepts *optional* additional arguments for easier debugging.
 */
export const logError = (error: Error, { extras }: ErrorData = {}) => {
  // Guard against RUM not being initialized (e.g. datadogRumEnabled=false or very early in boot).
  if (datadogRum.getInternalContext()) {
    datadogRum.addError(error, extras);
  }
};
